// ArChat Auto-Normalized File
// Created: 12-03-2026 22:38:36
// Author: SIVOL® - Aldo Frias - Argentina

/**
 * Autor: SIVOL® - Aldo Frias - Argentina
 * Fecha: 11/03/2026 22:50 (Argentina - UTC-3)
 * @file LoadingContext.jsx
 * @description Contexto global de carga (preloader) para operaciones async
 */

import { createContext, useContext, useState, useCallback } from 'react';
import PreloaderOverlay from '../components/UI/PreloaderOverlay';

const LoadingContext = createContext(null);

export function useLoading() {
  const context = useContext(LoadingContext);
  if (!context) {
    throw new Error('useLoading debe usarse dentro de LoadingProvider');
  }
  return context;
}

export function LoadingProvider({ children }) {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const showLoading = useCallback((msg = '') => {
    setMessage(msg);
    setLoading(true);
  }, []);

  const hideLoading = useCallback(() => {
    setLoading(false);
    setMessage('');
  }, []);

  const value = {
    showLoading,
    hideLoading,
    isLoading: loading,
    loadingMessage: message,
  };

  return (
    <LoadingContext.Provider value={value}>
      {children}
      <PreloaderOverlay visible={loading} message={message} />
    </LoadingContext.Provider>
  );
}
